module.exports = __webpack_public_path__ + "static/media/test12_2.b2c93e0d.png";